"use strict";

$(document)
// Переключатель режимов редактирования
.on("click.applicationjs", "html:not(.preview) #methods_list", function (e) {
    var $this = $(this),
        active = !$this.hasClass("active");
    setTimeout(function () {
        $this.toggleClass("active", active).find(".selected.method").toggleClass("qtip-disabled", active);
        $(".qtip").hide();
    }, 0);
})
.on("click.applicationjs", "body", function (e) {
    var $list = $("#methods_list");
    if ($list.hasClass("active")) {
        $list.removeClass("active").find(".selected.method").removeClass("qtip-disabled")
    }
});
